import { createContext } from 'react';

/** One bucket of the timeseries, drawn as a single coloured band. */
export type ActivityOverviewData = {
    value: number;
    taskCount: number;
    alertCount: number;
    start: Date;
    end?: Date;
    fill: string;
};

/** One bucket of the timeseries, drawn as a stacked bar. */
export type TasksAndAlertsChartData = {
    taskCount: number;
    alertCount: number;
    start: Date;
    end?: Date;
};

export type DayOfTheWeekActivityData = {
    taskCount: number;
    alertCount: number;
    dayOfTheWeek: string;
};

export type RealVsFalseAlertData = {
    value: number;
    fill: string;
    label: string;
};

export type AlertTypeData = {
    label: string;
    value: number;
    fill: string;
};

/** A single headline number and the range it covers. */
export type SingleValueData = {
    value: number;
    dateString: string;
};

export interface TasksAndAlertsAnalyticsContextData {
    status: 'error' | 'success' | 'pending';
    activityOverviewData: ActivityOverviewData[];
    tasksAndAlertsData: TasksAndAlertsChartData[];
    dayOfTheWeekActivityData: DayOfTheWeekActivityData[];
    realVsFalseAlertData: RealVsFalseAlertData[];
    alertTypeData: AlertTypeData[];
    totalTasksData: SingleValueData | null;
    totalAlertsData: SingleValueData | null;
    totalRealAlertsData: SingleValueData | null;
    dateString: string | null;
}

export const TasksAndAlertsAnalyticsContext = createContext<
    TasksAndAlertsAnalyticsContextData | undefined
>(undefined);
